import {Alert, ConfigProvider} from 'antd';
import {ReactElement} from 'react';

import {gray2, gray4, gray7} from '../../../../../../css/var-export.scss';
import {useDocumentationLinks} from '../../../../../../provider/help-links/help-links-hook';
import {Locale} from '../../../../../../provider/locale/localization';

export function HeaderAlert(): ReactElement {
    const {sourceYandexLinking} = useDocumentationLinks();

    return (
        <ConfigProvider
            theme={{
                components: {
                    Alert: {
                        colorInfo: gray7,
                        colorInfoBg: gray2,
                        colorInfoBorder: gray4,
                    },
                },
            }}
        >
            <Alert
                message={
                    <Locale
                        stringKey="SOURCE_SETTINGS__YANDEX_ALERT__MESSAGE"
                        valueMap={{
                            link: sourceYandexLinking ? (
                                <a href={sourceYandexLinking}>
                                    <Locale stringKey="SOURCE_SETTINGS__YANDEX_ALERT__MESSAGE__LINK" />
                                </a>
                            ) : (
                                ''
                            ),
                        }}
                    />
                }
                showIcon
                type="info"
            />
        </ConfigProvider>
    );
}
